const getGeography = `
    query {
        countries {
            code
            name
            currency
        }
        states {
            code: stateCode
            countryCode
            name
        }
    }
`;

export default getGeography;
